import React from 'react';
import { ReportVisibilityOptions } from './ReportSharingOptions';

export const managementPageSelectionOptions: ReportVisibilityOptions[] = [
  {
    value: 'public',
    heading: (
      <>
        Public <span className="blue-text">(Recommended)</span>
      </>
    ),
    subHeading: (
      <>
        <strong>Make all reports visible to any donor.</strong>
        <br />
        Your reports will be discoverable across our network of trusted
        platforms—such as Charity Navigator and Blackbaud—and can be shared via
        a public link, making them visible to any donor. This helps funders find
        and understand your work without requiring donor-specific reports.
      </>
    ),
  },
  {
    value: 'custom',
    heading: 'Restricted (You decide what to share)',
    subHeading: (
      <>
        <strong>Choose visibility on a report-by-report basis.</strong>
        <br />
        Select which programs or individual reports are shared publicly and
        which remain restricted. Use this option if some reports are intended
        for broader audiences while others are meant for specific funders.
      </>
    ),
  },
  {
    value: 'private',
    heading: 'All Restricted',
    subHeading: (
      <>
        <strong>Do not share any reports publicly.</strong>
        <br />
        All reports will remain private and visible only to the donors you work
        with directly. Reports will not be discoverable through the network or
        shared via public links.
      </>
    ),
  },
];

export const loginModalSelectionOptions: ReportVisibilityOptions[] = [
  {
    value: 'public',
    heading: (
      <>
        Public <span className="blue-text">(Recommended)</span>
      </>
    ),
    subHeading: (
      <>
        <strong>Make all reports visible to any donor.</strong>
        <br />
        All historical and yet-to-be-created reports will be discoverable across
        our network of trusted platforms—such as Charity Navigator and
        Blackbaud—and can be shared via a public link, making them visible to
        any donor. This helps funders find and understand your work without
        requiring donor-specific reports.
      </>
    ),
  },
  {
    value: 'custom',
    heading: 'Restricted (You decide what to share)',
    subHeading: (
      <>
        <strong>Choose visibility on a report-by-report basis.</strong>
        <br />
        Select which programs or individual reports are shared publicly and
        which remain restricted. Use this option if some reports are intended
        for broader audiences while others are meant for specific funders.
      </>
    ),
  },
  {
    value: 'private',
    heading: 'All Restricted',
    subHeading: (
      <>
        <strong>Do not share any reports publicly.</strong>
        <br />
        Choose this option only if all your reports are tailored to a particular
        funder or contain sensitive information, keeping them private and
        visible only to the donors you work with directly. Reports will not be
        discoverable through the network or shared via public links.
      </>
    ),
  },
];

export const reportVisibilitySubOptions: ReportVisibilityOptions[] = [
  {
    value: 'public',
    heading: 'New programs will be public',
    subHeading: 'Reports created within new programs will be public.',
  },
  {
    value: 'private',
    heading: 'New programs will be restricted',
    subHeading:
      'Reports created within new programs will be restricted to selected donors.',
  },
];
